import { z } from 'zod';

/**
 * `GET /api/me/personal/account.json` — a machine-readable copy of the data
 * Projoint holds about me (GDPR art. 15 / 20, audit 2026-10 item 17). Only my
 * own data: no other person's content leaves through here.
 */
const IsoDate = z.string();

export const AccountExportSchema = z.object({
  format: z.literal('projoint-account-export'),
  version: z.literal(1),
  exportedAt: IsoDate,
  profile: z.object({
    id: z.string().uuid(),
    email: z.string(),
    username: z.string(),
    name: z.string(),
    bio: z.string().nullable(),
    timezone: z.string(),
    locale: z.string().nullable(),
    emailVerifiedAt: IsoDate.nullable(),
    twoFactorEnabled: z.boolean(),
    githubLogin: z.string().nullable(),
    createdAt: IsoDate,
  }),
  teams: z.array(
    z.object({
      name: z.string(),
      slug: z.string(),
      kind: z.string(),
      role: z.string().nullable(),
      active: z.boolean(),
      joinedAt: IsoDate,
    }),
  ),
  personalTasks: z.array(
    z.object({
      project: z.string(),
      key: z.string(),
      title: z.string(),
      status: z.string().nullable(),
      priority: z.number().int(),
      dueAt: IsoDate.nullable(),
      completedAt: IsoDate.nullable(),
      createdAt: IsoDate,
      archived: z.boolean(),
    }),
  ),
  sessions: z.array(
    z.object({
      createdAt: IsoDate,
      lastUsedAt: IsoDate,
      revokedAt: IsoDate.nullable(),
      userAgent: z.string().nullable(),
      ipAddress: z.string().nullable(),
    }),
  ),
  accessTokens: z.array(
    z.object({
      name: z.string(),
      prefix: z.string(),
      scopes: z.array(z.string()),
      createdAt: IsoDate,
      lastUsedAt: IsoDate.nullable(),
      revokedAt: IsoDate.nullable(),
    }),
  ),
});
export type AccountExport = z.infer<typeof AccountExportSchema>;
